import appConfigApi from './api/appConfigApi';

const api = {
  appConfig: appConfigApi,
};

export default api;
